"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabList = void 0;
const react_1 = __importStar(require("react"));
const TabsContext_1 = require("../../TabsContext");
const Tab_1 = require("../Tab");
const TabList_styles_1 = require("./TabList.styles");
/**
 * @deprecated please use <Ds.Tabs.List/> instead
 */
const TabList = ({ tabs }) => {
    const { selectedTabId, setSelectedTabId, getTabPanels } = (0, TabsContext_1.useTabs)();
    // Get the new tab when moving along
    const getNextTabFromIndex = (currentIndex, offset) => {
        const newIndex = currentIndex + offset;
        if (tabs[newIndex] !== undefined &&
            newIndex >= 0 &&
            newIndex < tabs.length) {
            return tabs[newIndex].tabId;
        }
        return null;
    };
    // Auto select first tab if none is selected
    (0, react_1.useEffect)(() => {
        // Want to go to the first tab
        const firstTabId = tabs.length > 0 ? tabs[0].tabId : null;
        if (selectedTabId === undefined && firstTabId !== null) {
            setSelectedTabId &&
                setSelectedTabId({ tabId: firstTabId, isUserSelect: false });
        }
    }, [tabs, selectedTabId, setSelectedTabId]);
    // Check that everything is as we expect - the TabList has at least one tab, the number of tab buttons matches the panels, all provided panel ids have a matching tab button,
    (0, react_1.useEffect)(() => {
        const tabPanelIds = getTabPanels();
        const tabListIds = tabs.map((tab) => tab.tabId);
        const uniqueTabListIds = new Set(tabListIds);
        if (uniqueTabListIds.size === 0) {
            console.error(`Invalid tabs prop: TabList expected to receive an array of tabs, but instead received [${tabs.join(",")}]. At least one tab is required in order to use the Tabs component.`);
            return;
        }
        const missingTabPanelIds = tabPanelIds.filter((id) => uniqueTabListIds.has(id) === false);
        if (missingTabPanelIds.length > 0) {
            console.error(`Unexpected Tabs.Panel: Encountered a Tabs.Panel with tabId="${missingTabPanelIds[0]}" but the available ids in Tabs.TabList are "${tabListIds.join('","')}".`);
            return;
        }
        if (tabListIds.length !== tabPanelIds.length) {
            console.error(`Tab count mismatch: Expected the same number of TabList tabs and TabPanels, but there are ${tabListIds.length} TabList tabs and ${tabPanelIds.length} TabPanels.`);
            return;
        }
    }, [tabs, getTabPanels]);
    const selectTabAndFocus = (tabId) => {
        const nextTab = document.getElementById(tabId);
        nextTab && nextTab.focus();
        setSelectedTabId && setSelectedTabId({ tabId, isUserSelect: true });
    };
    const handleKeyActions = (e) => {
        // Only handle key actions if there is a tab selected
        if (selectedTabId === undefined)
            return;
        if (tabs.length === 0)
            return;
        const tabIndex = tabs.findIndex((tab) => tab.tabId === selectedTabId);
        if (tabIndex === -1)
            return;
        switch (e.key) {
            case "Escape":
                const tabElement = document.getElementById(selectedTabId);
                tabElement !== null && tabElement.blur();
                break;
            case "ArrowRight":
                const nextTabId = getNextTabFromIndex(tabIndex, 1);
                if (nextTabId !== null) {
                    selectTabAndFocus(nextTabId);
                }
                break;
            case "ArrowLeft":
                const prevTabId = getNextTabFromIndex(tabIndex, -1);
                if (prevTabId !== null) {
                    selectTabAndFocus(prevTabId);
                }
                break;
            case "Home":
                e.preventDefault();
                // Want to go to the first tab
                const firstTabId = tabs[0].tabId;
                if (firstTabId !== null) {
                    selectTabAndFocus(firstTabId);
                }
                break;
            case "End":
                e.preventDefault();
                // Want to go to the last tab
                const lastTabId = tabs[tabs.length - 1].tabId;
                if (lastTabId !== null) {
                    selectTabAndFocus(lastTabId);
                }
                break;
            default:
                break;
        }
    };
    return (react_1.default.createElement(TabList_styles_1.StyledTabList, { role: "tablist" }, tabs.map((tab) => (react_1.default.createElement(Tab_1.Tab, Object.assign({ key: tab.tabId }, tab, { onKeyDown: handleKeyActions }))))));
};
exports.TabList = TabList;
//# sourceMappingURL=TabList.js.map